import { render, staticRenderFns } from "./pageheader.vue?vue&type=template&id=2daa213e&scoped=true"
import script from "./pageheader.vue?vue&type=script&lang=js"
export * from "./pageheader.vue?vue&type=script&lang=js"
import style0 from "./pageheader.vue?vue&type=style&index=0&id=2daa213e&prod&scoped=true&lang=less"
import style1 from "./pageheader.vue?vue&type=style&index=1&id=2daa213e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa213e",
  null
  
)

export default component.exports